<template>
  <section>
    <TableListing :items="items" :fields="fieldsAll" :showPaginationRow="true" :pagination.sync="pagination" :options.sync="tableOptions">
      <template v-slot:cell(amount)="data">
        <span>$ {{ parseFloat(data.item.amount).toFixed(2) }}</span>
      </template>
      <template v-slot:cell(projectId)="data">
        <span v-if="myProjects && myProjects.find(a => a.id == data.item.projectId)">{{ myProjects.find(a => a.id ==
        data.item.projectId).name }}</span>
        <span v-else>-</span>
      </template>
      <template v-slot:cell(unitPrice)="data">
        <span>
          $ {{ parseFloat(parseFloat(data.item.unitPrice)).toFixed(2) }}
        </span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing } from '@/views/components/custom';
import { mapGetters } from 'vuex';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'OrderedStorefrontItemsReport-view',
  components: {
    TableListing: TableListing
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      projectsList: 'getProjectsList',
      myProjs: 'getMyProjects',
      countryCodeList: 'getCountryCodeList',
      USAStateCodeList: 'getUSAStateCodeList'
    })
  },
  mounted() {
    this.tableOptions.totalRows = this.items.length;
  },
  data() {
    return {
      pagination: {
        sortBy: '',
        sortDesc: false,
        perPage: 10,
        page: 1
      },
      tableOptions: {
        totalRows: 10,
        loadedAll: true
      },
      fieldsAll: [
        { key: 'projectId', label: 'Storefront', sortable: true },
        { key: 'ordersCount', label: 'Orders', sortable: true },
        { key: 'ordersShipped', label: 'Orders Shipped', sortable: true },
      ],
    }
  }
}
</script>

<style>

</style>
